import React from "react";
import "./PhotoCollage.css";

const PhotoCollage = () => {
  return (
    <div className="photo-collage">
      <div className="triangle">
        <div className="icon icon-1">
          <i class="fa-solid fa-code"></i>
        </div>
        <div className="icon icon-2">
          <i class="fa-solid fa-code-branch"></i>
        </div>
        <div className="icon icon-3">
          <i class="fa-solid fa-masks-theater"></i>
        </div>
      </div>
    </div>
  );
};

export default PhotoCollage;
